// METIS Hub wording — namespace "settings" (ko), 345 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/settings.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const settings: Record<string, string> = {
  "settings.desc": "내 기록에 무엇이 남는지 정하고, 누가 봤는지 확인하고, 화면을 내게 맞춰요. 모든 역할이 같은 화면에서 본인 것만 다뤄요.",
  "settings.scopeNote": "머리줄의 보기 범위와 상관없이 이 화면은 늘 내 기록·동의만 다뤄요.",
  "settings.tab.label": "내 기록·동의·설정",
  "settings.tab.level": "기록 수준",
  "settings.tab.views": "누가 내 기록을 봤나요",
  "settings.tab.me": "내 정보·알림·화면",
  "settings.st.label": "지금 기록 상태",
  "settings.st.on": "기록 중",
  "settings.st.off": "꺼짐",
  "settings.st.recording": "{level}까지 · 마지막 저장 {rel} · 연결 PC {n}대",
  "settings.st.recordingCustom": "직접 고른 조합 · 마지막 저장 {rel} · 연결 PC {n}대",
  "settings.st.noSave": "아직 저장된 기록 없음",
  "settings.st.paused": "일시 중지 · {until}까지",
  "settings.st.reconsent": "재동의 필요 · 다시 동의하기 전까지 새 기록을 저장하지 않아요",
  "settings.st.withdrawn": "철회 · 언제든 다시 동의할 수 있어요",
  "settings.st.before": "동의 전 · 동의하기 전에는 아무것도 저장하지 않아요",
  "settings.st.pause": "잠시 멈추기",
  "settings.st.resume": "다시 시작",
  "settings.st.agree": "안내문 읽고 동의하기",
  "settings.st.reagree": "다시 동의하기",
  "settings.re.title": "안내문 {v}에 다시 동의해 주세요",
  "settings.re.desc": "{changes} 다시 동의하기 전의 기록은 저장하지 않아요.",
  "settings.re.act": "바뀐 점 보고 동의하기",
  "settings.lv.q": "어디까지 기록할까요?",
  "settings.lv.tech": "기록 수준 · 4단계 누적 · 회사 상한 ∩ 내 선택",
  "settings.lv.sum": "지금 {level}까지 기록하고 있어요. 회사 상한은 {cap}{ie}.",
  "settings.lv.sumCustom": "지금 직접 고른 조합({items})으로 기록하고 있어요. 회사 상한은 {cap}{ie}.",
  "settings.lv.sumOff": "지금은 기록하지 않아요({why}). 회사 상한은 {cap}{ie}.",
  "settings.lv.pick": "기록 수준 고르기",
  "settings.lv.cap": "회사 상한",
  "settings.lv.capAbove": "회사 상한보다 높아요",
  "settings.lv.current": "지금 적용 중",
  "settings.lv.adds": "더해지는 것",
  "settings.lv.add.1": "시각·도구·AI 모델·사용량(토큰)·시간·성공 여부",
  "settings.lv.add.2": "내가 쓴 질문 글",
  "settings.lv.add.3": "AI 답변 글",
  "settings.lv.add.4": "명령·파일 경로·바뀐 내용",
  "settings.lv.frame": "{level}{eul} 고르면",
  "settings.lv.f.send": "보내는 것",
  "settings.lv.f.notSend": "보내지 않는 것",
  "settings.lv.f.local": "내 PC에만 남는 것",
  "settings.lv.f.revoke": "철회 방법",
  "settings.lv.1.send": "시각·도구·AI 모델·사용량(토큰)·시간·성공 여부",
  "settings.lv.1.notSend": "질문 글 · AI 답변 글 · 명령·파일 경로·바뀐 내용 · AI의 중간 생각",
  "settings.lv.1.local": "질문·답변·작업 내용은 내 PC에 있는 AI 도구의 대화 기록 파일에만 있어요.",
  "settings.lv.2.send": "① 기본 정보 + 내가 쓴 질문 글(가림 처리 뒤 암호화해 저장)",
  "settings.lv.2.notSend": "AI 답변 글 · 명령·파일 경로·바뀐 내용 · AI의 중간 생각",
  "settings.lv.2.local": "AI 답변과 작업 내용은 내 PC에만 있어요.",
  "settings.lv.3.send": "② + AI 답변 글(Codex 답변은 비공식 설정이라 일부만 올 수 있어요)",
  "settings.lv.3.notSend": "명령·파일 경로·바뀐 내용 · 도구 결과 · AI의 중간 생각",
  "settings.lv.3.local": "명령과 파일 내용은 내 PC에만 있어요.",
  "settings.lv.4.send": "③ + 명령·파일 경로·바뀐 내용(경로는 끝 두 단계만 라벨로 보여요)",
  "settings.lv.4.notSend": "도구 결과(파일 내용·명령 출력) · 비밀 파일의 내용 · AI의 중간 생각 · 키 입력·화면·네트워크",
  "settings.lv.4.local": "파일 내용 전체와 명령 출력은 내 PC에만 있어요.",
  "settings.lv.revoke": "언제든 낮추거나, 잠시 멈추거나, 동의를 철회할 수 있어요. 이미 저장된 글은 보관 기간({days}일)이 지나면 지워지고, 바로 지우려면 기록 삭제 요청을 하세요.",
  "settings.lv.4.warn": "명령·도구 입력에 비밀값이 들어갈 수 있어요. 가림은 정해진 형식만 찾아요.",
  "settings.lv.change": "{from} → {to}{ro} 바꿀까요?",
  "settings.lv.apply": "이 수준으로 바꾸기",
  "settings.lv.keep": "그대로 두기",
  "settings.lv.c4.title": "작업 상세까지 기록할까요?",
  "settings.lv.c4.body": "명령·파일 경로·바뀐 내용이 회사 서버에 남아요. 명령이나 도구 입력에 비밀값이 섞이면 가림이 놓칠 수 있어요(가림은 정해진 형식만 찾아요).",
  "settings.lv.c4.check": "비밀값이 섞일 수 있다는 걸 알고 켤게요",
  "settings.lv.c4.need": "확인란을 골라야 켤 수 있어요",
  "settings.lv.cd.title": "{to}{ro} 낮출까요?",
  "settings.lv.cd.body": "바꾼 뒤 들어오는 기록부터 적용돼요. 이미 저장된 글은 보관 기간({days}일)이 지나면 지워져요. 바로 지우려면 기록 삭제 요청을 하세요.",
  "settings.lv.cu.title": "{to}{ro} 올릴까요?",
  "settings.lv.cu.body": "바꾼 뒤 들어오는 기록부터 적용돼요. 언제든 다시 낮출 수 있어요.",
  "settings.lv.changed": "기록 수준을 {to}{ro} 바꿨어요 · 동의 이력에 남았어요",
  "settings.lv.resync.title": "CLI 설정을 다시 받아야 해요",
  "settings.lv.resync.desc": "내 PC의 AI 도구가 바뀐 수준대로 보내려면 설정을 다시 받아 적용하세요. 그 전까지 수준 밖 항목은 서버가 버려요.",
  "settings.lv.resync.act": "설정 다시 받기",
  "settings.lv.blocked.withdrawn": "동의를 철회했어요. 다시 동의하면 기록 수준을 고를 수 있어요.",
  "settings.lv.blocked.reconsent": "안내문 {v}에 다시 동의하면 기록 수준을 바꿀 수 있어요.",
  "settings.lv.blocked.before": "안내문에 동의하면 기록 수준을 고를 수 있어요.",
  "settings.lv.note.admin": "회사 상한은 기록 정책에서 정해요. 다른 사람의 기록 수준은 상한을 낮추는 방향으로만 바꿀 수 있어요.",
  "settings.lv.note.adminLink": "기록 정책 열기",
  "settings.lv.note.manager": "팀원의 기록 수준·동의는 본인만 바꿀 수 있어요. 매니저도 여기서는 내 것만 다뤄요.",
  "settings.lv.emptyWhat": "아직 기록에 동의하지 않았어요.",
  "settings.lv.emptyNot": "동의하기 전에는 아무것도 저장하지 않아요. AI 도구를 쓰지 않았다는 뜻은 아니에요.",
  "settings.adv.toggle": "직접 고르기(고급)",
  "settings.adv.custom": "직접 고른 조합",
  "settings.adv.desc": "항목을 하나씩 켜고 꺼요. 실제로 남는 것은 회사 상한과 내 선택이 모두 켜진 항목이에요.",
  "settings.adv.basicLocked": "동의하는 동안 늘 켜져 있어요. 멈추려면 잠시 멈추기나 동의 철회를 쓰세요.",
  "settings.item.prompt.d": "내가 AI에게 보낸 질문",
  "settings.item.answer.d": "AI 답변(Codex 답변은 비공식 설정)",
  "settings.item.work_detail.d": "명령·파일 경로·바뀐 내용",
  "settings.item.tool_output.d": "파일 내용·명령 출력 일부 · 켤 때 위험을 확인해요",
  "settings.item.server_upload.d": "PC 도우미가 모아 둔 기록을 서버로 올려요",
  "settings.adv.changed": "바뀐 항목 {n}개",
  "settings.adv.save": "이대로 저장",
  "settings.adv.reset": "되돌리기",
  "settings.adv.saved": "항목별 선택을 저장했어요 · 동의 이력에 남았어요",
  "settings.adv.riskTitle": "도구 결과를 켤까요?",
  "settings.adv.riskBody": "파일 내용·명령 출력 일부가 회사 서버에 남아요. 비밀값·개인정보가 섞일 수 있고, 가림은 정해진 형식만 찾아요.",
  "settings.adv.riskCheck": "위험을 알고 켤게요",
  "settings.adv.riskOn": "켜기",
  "settings.r.q": "내 기록으로 무엇을 할 수 있나요?",
  "settings.r.tech": "사용자 권리 · 잠시 멈추기 · 사본 · 삭제 요청 · 동의 철회",
  "settings.r.pause.t": "잠시 멈추기",
  "settings.r.pause.d": "1시간·오늘·직접 정한 시각까지 멈춰요. 멈춘 동안 생긴 기록은 늦게 도착해도 저장하지 않아요.",
  "settings.r.pause.now": "{until}까지 멈춰 있어요.",
  "settings.r.copy.t": "내 기록 사본 받기",
  "settings.r.copy.d": "내 기록(글 포함)을 사유 없이 받아요. 받은 일은 열람·변경 이력에 남아요.",
  "settings.r.copy.btn": "사본 받기",
  "settings.r.del.t": "기록 삭제 요청",
  "settings.r.del.d": "대화 하나·기간·전체를 지워 달라고 요청해요. 요청하면 바로 조회가 막혀요.",
  "settings.r.del.btn": "삭제 요청",
  "settings.r.wd.t": "동의 철회",
  "settings.r.wd.d": "기록을 멈추고, 지금까지의 기록 전체 삭제 요청이 함께 만들어져요. 언제든 다시 동의할 수 있어요.",
  "settings.r.wd.btn": "동의 철회",
  "settings.r.notice.t": "안내문",
  "settings.r.notice.d": "{v} · {date} 게시 · {agreed}",
  "settings.r.notice.agreed": "{date}에 동의함",
  "settings.r.notice.need": "다시 동의해야 해요",
  "settings.r.notice.btn": "안내문 보기",
  "settings.r.sum": "안내문 {v}에 {date} 동의했고, 처리 중인 삭제 요청은 없어요.",
  "settings.r.sumPending": "처리를 기다리는 삭제 요청이 {n}건 있어요. 요청한 기록은 이미 조회가 막혔어요.",
  "settings.r.sumNeed": "안내문 {v}에 아직 동의하지 않았어요.",
  "settings.r.what.t": "무엇이 기록되나요?",
  "settings.r.what.d": "항목마다 도구·사용 방식별로 남는 것과 남지 않는 것을 봐요. 버전별로 보낼 수 있는 항목은 지원표에서 봐요.",
  "settings.r.what.btn": "무엇이 기록되나요",
  "settings.r.what.btn2": "지원표",
  "settings.d.list": "내 삭제 요청",
  "settings.d.st.pending": "처리 대기 · {due} 자동 삭제",
  "settings.d.st.done": "삭제함 · {when}",
  "settings.d.st.held": "보류(법적 보관)",
  "settings.d.st.rejected": "반려 · 다시 보여요",
  "settings.d.n": "대화 {n}건",
  "settings.d.memo": "처리 메모: {m}",
  "settings.d.sc.one": "대화 #{no}",
  "settings.d.sc.range": "{from}~{to}",
  "settings.d.sc.all": "전체 기록",
  "settings.p.title": "기록을 잠시 멈출까요?",
  "settings.p.1h": "1시간",
  "settings.p.1hD": "{until}까지",
  "settings.p.today": "오늘 자정까지",
  "settings.p.custom": "직접 정하기",
  "settings.p.until": "다시 시작할 때",
  "settings.p.hint": "멈춘 동안 생긴 기록은 늦게 도착해도 저장하지 않아요. 언제든 다시 시작할 수 있어요.",
  "settings.p.ok": "멈추기",
  "settings.p.done": "{until}까지 기록을 멈췄어요",
  "settings.p.resumed": "기록을 다시 시작했어요",
  "settings.c.title": "내 기록 사본 받기",
  "settings.c.period": "기간",
  "settings.c.p30": "최근 30일",
  "settings.c.p90": "최근 90일",
  "settings.c.all": "전체",
  "settings.c.format": "형식",
  "settings.c.withText": "질문·답변 글 포함",
  "settings.c.withTextD": "본인 사본은 글을 넣을 수 있어요(가린 상태 그대로).",
  "settings.c.make": "사본 만들기",
  "settings.c.ready": "사본이 준비됐어요 · 기록 {n}건",
  "settings.c.download": "{file} 내려받기",
  "settings.c.note": "서버에는 파일을 남기지 않아요. 받은 일은 열람·변경 이력에 남아요.",
  "settings.c.empty": "이 기간에는 내 기록이 없어요.",
  "settings.d.title": "기록 삭제를 요청할까요?",
  "settings.d.scope": "지울 범위",
  "settings.d.one": "대화 하나",
  "settings.d.range": "기간",
  "settings.d.all": "전체",
  "settings.d.pick": "지울 대화",
  "settings.d.from": "시작일",
  "settings.d.to": "끝일",
  "settings.d.invalid": "시작일이 끝일보다 늦어요",
  "settings.d.effect": "요청하면 바로 모든 화면의 목록·상세·합계에서 빠져요. 운영 담당이 처리하거나 7일 뒤 자동으로 지워요. 비용 정산용 사용량은 가명 합계로 남아요.",
  "settings.d.allWarn": "전체를 지우면 지금까지 서버가 받은 내 기록이 모두 지워져요. 다시 동의한 뒤의 기록은 남아요.",
  "settings.d.ok": "삭제 요청하기",
  "settings.d.done": "삭제를 요청했어요 · 바로 조회가 막혔어요",
  "settings.d.noConv": "고를 대화가 없어요",
  "settings.w.title": "동의를 철회할까요?",
  "settings.w.lead": "철회하면 이렇게 돼요.",
  "settings.w.r1": "지금부터 기록을 저장하지 않아요.",
  "settings.w.r2": "지금까지의 기록 전체 삭제 요청이 함께 만들어져요.",
  "settings.w.r3": "언제든 다시 동의할 수 있어요. AI 도구 자체를 쓰는 데는 영향이 없어요(회사 키 게이트웨이는 쓸 수 없어요).",
  "settings.w.hold": "길게 눌러 철회하기",
  "settings.w.holdHint": "버튼을 1.2초 동안 누르고 있으세요. 키보드는 Space나 Enter를 누르고 있으면 돼요.",
  "settings.w.done": "동의를 철회했어요 · 전체 삭제 요청을 만들었어요",
  "settings.w.undoHint": "{s}초 안에 되돌리면 동의와 삭제 요청이 원래대로 돌아가요",
  "settings.w.undone": "철회를 되돌렸어요 · 삭제 요청도 취소했어요",
  "settings.n.kicker": "안내문 {v} · {date} 게시",
  "settings.n.title": "내 AI 사용 기록 안내",
  "settings.n.changes": "이번 버전에서 바뀐 점",
  "settings.n.hash": "본문 지문 {hash}",
  "settings.n.scroll": "끝까지 읽으면 동의할 수 있어요",
  "settings.n.end": "안내문 끝이에요.",
  "settings.n.agree": "동의하기",
  "settings.n.agreed": "안내문 {v}에 동의했어요 · 동의 이력에 남았어요",
  "settings.n.demo": "데모 상태라 동의를 저장하지 않았어요",
  "settings.pr.q": "내 기록은 어떻게 보호되나요?",
  "settings.pr.tech": "내 기록 보호 현황 · 적용 정책 · 가림 확인",
  "settings.pr.sum": "최근 30일 동안 {list}{eul} 가려서 저장했어요.",
  "settings.pr.sumNone": "최근 30일 동안 가려서 저장한 값이 없어요.",
  "settings.pr.keep": "남는 것",
  "settings.pr.notKeep": "남지 않는 것",
  "settings.pr.ret": "보관 기간",
  "settings.pr.who": "볼 수 있는 사람",
  "settings.pr.mask": "가림 확인",
  "settings.pr.never": "AI의 중간 생각 · API 요청·응답 본문 전체 · 키 입력·화면·네트워크",
  "settings.pr.retLine": "글 {c}일 · 사용량·기본 정보 {u}일 · 백업 최대 {b}일",
  "settings.pr.who.self": "나 — 내 기록과 글 전부",
  "settings.pr.who.flow": "{roles} — 사유·다시 로그인 확인·대화 단위 허가를 거쳐 글을 열어요. 열면 ‘누가 내 기록을 봤나요’에 남아요.",
  "settings.pr.who.team": "{roles} — 팀 사용량과 팀원별 합계만 봐요. 질문·답변 글은 볼 수 없어요.",
  "settings.pr.who.meta": "{roles} — 기본 정보와 합계만 봐요. 글은 볼 수 없어요.",
  "settings.pr.col.kind": "가린 것",
  "settings.pr.col.d7": "최근 7일",
  "settings.pr.col.d30": "최근 30일",
  "settings.pr.secret": "비밀 파일 접근(내용은 저장 안 함)",
  "settings.pr.secretNone": "비밀 파일 접근은 없었어요.",
  "settings.pr.limit": "가림은 정해진 형식만 찾으므로 완벽하지 않아요.",
  "settings.pr.cond": "최근 30일 · 내 기록",
  "settings.pr.n": "건",
  "settings.pr.emptyWhat": "최근 30일 동안 받은 내 기록이 없어요.",
  "settings.pr.emptyNot": "기록이 없다고 AI를 안 쓴 것은 아니에요. 동의·연결 상태를 확인해 보세요.",
  "settings.h.q": "언제 무엇에 동의했나요?",
  "settings.h.tech": "내 동의 이력 · 추가만 돼요(고치거나 지울 수 없어요)",
  "settings.h.sum": "처음 동의한 날은 {first}이고, 마지막 변경은 {last}{ie}.",
  "settings.h.sumOne": "{first}에 동의했어요.",
  "settings.h.col.when": "시각",
  "settings.h.col.what": "무엇을",
  "settings.h.col.level": "기록 수준",
  "settings.h.col.notice": "안내문",
  "settings.h.source": "동의 기록",
  "settings.h.a.grant": "동의함",
  "settings.h.a.change": "기록 수준을 바꿈",
  "settings.h.a.reconsent": "안내문에 다시 동의함",
  "settings.h.a.pause": "잠시 멈춤 · {until}까지",
  "settings.h.a.resume": "다시 시작함",
  "settings.h.a.custom": "항목을 직접 고름",
  "settings.h.a.withdraw": "동의를 철회함",
  "settings.h.a.withdraw_undo": "철회를 되돌림",
  "settings.h.custom": "직접 고른 조합",
  "settings.h.emptyWhat": "아직 동의 이력이 없어요.",
  "settings.h.emptyNot": "안내문에 동의하면 그때부터 이력이 쌓여요.",
  "settings.v.q": "누가 내 기록을 봤나요?",
  "settings.v.tech": "글 열람 · 개인별 보기 · 내보내기 · 삭제 처리 · 법적 보관",
  "settings.v.sum": "다른 사람이 내 기록을 {n}번 열었거나 다뤘어요({roles}). 가장 최근은 {rel}{ie}.",
  "settings.v.col.when": "시각",
  "settings.v.col.kind": "무엇을",
  "settings.v.col.who": "열람한 역할 · 사유 범주",
  "settings.v.col.reason": "사유",
  "settings.v.col.conv": "어떤 대화",
  "settings.v.roleOnly": "열람자 이름 대신 역할을 보여 줘요(문의: 개인정보 보호책임자 privacy@example.com).",
  "settings.v.denied": "거부됨 · 글은 열리지 않았어요",
  "settings.v.person": "내 사용 요약(개인별 보기)",
  "settings.v.export": "내 기록이 든 내보내기",
  "settings.v.hold": "법적 보관 대상",
  "settings.v.del": "삭제 처리 대상",
  "settings.v.filter": "종류",
  "settings.v.all": "전체",
  "settings.v.source": "열람·변경 이력",
  "settings.v.cond": "보관 2년 · 역할만 표시",
  "settings.v.emptyWhat": "아직 아무도 내 기록을 열어 보지 않았어요.",
  "settings.v.emptyNot": "다른 사람이 글을 열거나 개인별로 보면 여기에 역할·시각·사유가 남고 알림이 가요.",
  "settings.v.emptyNext": "알림 설정 보기",
  "settings.m.q": "내가 연 다른 사람의 기록은?",
  "settings.m.tech": "내 열람 활동 · 대화 단위 허가 · 개인별 보기",
  "settings.m.sum": "다른 사람의 기록을 {n}번 열었어요. 지금 열려 있는 허가는 {open}개예요.",
  "settings.m.sum2": "글 열람 {v}번 · 개인별 보기 {p}번 · 거부 {d}번이에요. 지금 열려 있는 허가는 {open}개예요.",
  "settings.m.noGrant": "허가 없이 보는 화면(개인별 보기)",
  "settings.m.col.when": "시각",
  "settings.m.col.target": "대상",
  "settings.m.col.cat": "사유 범주",
  "settings.m.col.reason": "사유",
  "settings.m.col.grant": "허가",
  "settings.m.left": "{min}분 남음",
  "settings.m.ended": "끝남",
  "settings.m.denied": "거부됨",
  "settings.m.person": "개인별 보기",
  "settings.m.note": "내가 연 기록은 당사자의 ‘누가 내 기록을 봤나요’에 내 역할로 남아요.",
  "settings.m.emptyWhat": "아직 다른 사람의 기록을 연 적이 없어요.",
  "settings.m.emptyNot": "글을 열 때마다 사유·다시 로그인 확인·대화 단위 허가를 거치고, 여기에 쌓여요.",
  "settings.a.q": "내 계정은 어떻게 되어 있나요?",
  "settings.a.tech": "이름·이메일·팀·역할·로그인 방식·다단계 인증(MFA)",
  "settings.a.name": "이름",
  "settings.a.email": "이메일",
  "settings.a.team": "팀",
  "settings.a.roles": "역할",
  "settings.a.job": "직무",
  "settings.a.login": "로그인 방식",
  "settings.a.login.google": "Google 계정(허용 도메인 example.com)",
  "settings.a.login.password": "아이디·비밀번호",
  "settings.a.mfa": "다단계 인증(MFA)",
  "settings.a.mfa.on": "켜짐 · 꼭 필요해요",
  "settings.a.mfa.onD": "글·실명·관리 권한이 있는 역할이라 다단계 인증을 써요({how}).",
  "settings.a.mfa.google": "Google 2단계 인증",
  "settings.a.mfa.totp": "인증 앱",
  "settings.a.mfa.off": "꺼짐 · 고를 수 있어요",
  "settings.a.mfa.offD": "일반 사용자는 고를 수 있어요. 켜려면 관리자에게 요청하세요.",
  "settings.a.pledge": "금지 용도 약정",
  "settings.a.pledge.done": "확인함 · 역할이 바뀌면 다시 확인해요",
  "settings.a.expires": "{date} 만료",
  "settings.a.managed": "이름·팀·역할은 관리자가 바꿔요.",
  "settings.a.sum": "{roles} 역할로 로그인해 있어요({how}).",
  "settings.a.sumMfa": "{roles} 역할이라 다단계 인증을 꼭 써요.",
  "settings.s.q": "어디에 로그인해 있나요?",
  "settings.s.tech": "로그인한 곳 · 기기·로그인 방식·마지막 사용",
  "settings.s.sum": "{n}곳에 로그인해 있어요.",
  "settings.s.this": "지금 이 브라우저",
  "settings.s.logout": "로그아웃",
  "settings.s.logoutAll": "다른 기기 모두 로그아웃",
  "settings.s.done": "그 기기에서 로그아웃했어요",
  "settings.s.doneAll": "다른 기기에서 모두 로그아웃했어요",
  "settings.s.last": "마지막 사용 {rel}",
  "settings.s.now": "지금",
  "settings.s.ruleAdmin": "관리 권한이 있어서 30분 동안 쓰지 않거나 8시간이 지나면 다시 로그인해요.",
  "settings.s.ruleMember": "2시간 동안 쓰지 않거나 12시간이 지나면 다시 로그인해요.",
  "settings.s.phone": "휴대폰",
  "settings.s.browser": "{dev} · {br}",
  "settings.nt.q": "어떤 알림을 받을까요?",
  "settings.nt.tech": "알림 · 화면 위 종과 메일",
  "settings.nt.conn": "내 기기 연결이 끊기면",
  "settings.nt.connD": "3일 넘게 받은 기록이 없거나 오류가 나면 알려요",
  "settings.nt.viewed": "내 기록이 열람되면",
  "settings.nt.viewedD": "꺼도 ‘누가 내 기록을 봤나요’에는 늘 남아요",
  "settings.nt.token": "연결 토큰이 곧 만료되면",
  "settings.nt.tokenD": "만료 14일 전에 알려요",
  "settings.nt.reconsent": "안내문에 다시 동의해야 하면",
  "settings.nt.reconsentD": "끌 수 없어요 · 다시 동의하기 전까지 새 기록을 저장하지 않아서 꼭 알려 드려요",
  "settings.nt.channel": "받는 곳",
  "settings.nt.ch.app": "화면 알림만",
  "settings.nt.ch.both": "화면 알림 + 메일",
  "settings.nt.emailUnavailable": "이메일 알림은 아직 사용할 수 없어요. 앱 안에서 알려드려요.",
  "settings.nt.mailTo": "메일은 {email}로 보내요.",
  "settings.nt.saved": "알림 설정을 바꿨어요",
  "settings.nt.sum": "알림 4가지 중 {n}가지를 받고 있어요({ch}).",
  "settings.nt.recent": "최근 받은 알림",
  "settings.nt.recentNone": "최근 받은 내 알림이 없어요.",
  "settings.ds.q": "화면을 어떻게 볼까요?",
  "settings.ds.tech": "언어·테마·숫자 단위·글자 크기·긴 글 줄바꿈",
  "settings.ds.lang": "언어",
  "settings.ds.theme": "테마",
  "settings.ds.num": "숫자 단위",
  "settings.ds.num.compact": "줄여서",
  "settings.ds.num.full": "전체 자릿수",
  "settings.ds.font": "글자 크기",
  "settings.ds.font.m": "보통",
  "settings.ds.font.l": "크게",
  "settings.ds.font.xl": "아주 크게",
  "settings.ds.wrap": "긴 글 줄바꿈",
  "settings.ds.wrapD": "긴 명령·바뀐 내용을 화면 폭에 맞춰 접어요",
  "settings.ds.preview": "미리보기",
  "settings.ds.sample": "최근 7일 내 사용량(토큰)",
  "settings.ds.sampleCmd": "내 최근 명령",
  "settings.ds.local": "숫자 단위·글자 크기·긴 글 줄바꿈은 이 브라우저에만 저장돼요. 목업에서는 아래 미리보기에 먼저 반영돼요.",
  "settings.ds.saved": "화면 설정을 저장했어요",
  "settings.ds.sum": "지금 {lang} · {theme} 테마 · 숫자 단위 ‘{num}’로 보고 있어요.",
};

export default settings;
